// ** React Imports
import { useEffect, useState, useRef } from "react";

// ** Third Party Components
import dayjs from "dayjs";
import { useSelector } from "react-redux";

// #####################################################

function formatTime(seconds) {
	return dayjs(new Date(0)).add(seconds, "second").format("mm:ss");
}

// #####################################################

export const useBlockResendEmail = () => {
	const lastEmailSentTime = useSelector(
		(state) => state.auth.register.registerForm.email.lastEmailSentTime
	);

	const initialSeconds = lastEmailSentTime;

	const [isResendDisabledByTime, setResendDisabledByTime] = useState(true);
	const [remainingTimeString, setRemainingTimeString] = useState("");
	const [remainingTimeNumber, setRemainingTimeNumber] =
		useState(initialSeconds);

	const timerRef = useRef(null);

	const startTimer = (seconds) => {
		// Czyścimy istniejący timer jeśli istnieje
		if (timerRef.current) {
			clearInterval(timerRef.current);
		}

		if (seconds <= 0) {
			setResendDisabledByTime(false);
			setRemainingTimeString(formatTime(0));
			setRemainingTimeNumber(0);
			return;
		}

		setResendDisabledByTime(true);
		setRemainingTimeNumber(seconds);
		setRemainingTimeString(formatTime(seconds));

		timerRef.current = setInterval(() => {
			setRemainingTimeNumber((prevTime) => {
				const newTime = Math.max(prevTime - 1, 0);
				setRemainingTimeString(formatTime(newTime));

				if (newTime <= 0) {
					setResendDisabledByTime(false);
					clearInterval(timerRef.current);
					timerRef.current = null;
				}

				return newTime;
			});
		}, 1000);
	};

	useEffect(() => {
		startTimer(initialSeconds);

		return () => {
			if (timerRef.current) {
				clearInterval(timerRef.current);
			}
		};
	}, [initialSeconds]);

	const setBlockResend = (block = true) => {
		setResendDisabledByTime(block);
	};

	const resetTimer = (seconds = 60) => {
		startTimer(seconds);
	};

	return {
		isResendDisabledByTime,
		remainingTimeString,
		remainingTimeNumber,
		setBlockResend,
		resetTimer,
	};
};
